import React, { useState } from "react";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import "./Navbar.css";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/"><img src="/Images/abasinlogo.png" alt="Logo" /></Link>
          <Link to="/"><span><img src="/Images/iata-logo-.png" alt="Logo" style={{width:'200px', height:'120px'}} /></span></Link>
        </div>

        {/* Hamburger for Mobile */}
        <div className="mobile-toggle" onClick={() => setMobileMenu(!mobileMenu)}>
          {mobileMenu ? <FaTimes /> : <FaBars />}
        </div>

        {/* Desktop & Mobile Menu */}
        <div className={`navbar-right ${mobileMenu ? "active" : ""}`}>
          {/* Logo inside mobile menu */}
          <div className="mobile-menu-logo">
            <Link to="/"><img src="/Images/abasinlogo.png" alt="Logo" /></Link>
          </div>

          <ul className="navbar-menu">
            <li><Link to="/" onClick={() => setMobileMenu(false)}>Home</Link></li>
            <li
              className={`dropdown ${productsOpen ? "active" : ""}`}
              onMouseEnter={() => window.innerWidth > 768 && setProductsOpen(true)}
              onMouseLeave={() => window.innerWidth > 768 && setProductsOpen(false)}
            >
              <Link to="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (window.innerWidth <= 768) setProductsOpen(!productsOpen);
                }}
              >
                Products <FaChevronDown className="arrow" />
              </Link>
              <div className={`mega-menu ${productsOpen ? "active" : ""}`}>
                <div className="mega-column">
                  <Link to="/services/flights" onClick={() => setMobileMenu(false)}>Flights</Link>
                  <Link to="/services/hotels" onClick={() => setMobileMenu(false)}>Hotels</Link>
                  <Link to="/services/packages" onClick={() => setMobileMenu(false)}>Packages</Link>
                </div>
              </div>
            </li>
            <li><Link to="/career" onClick={() => setMobileMenu(false)}>Careers</Link></li>
            <li><Link to="/about-us" onClick={() => setMobileMenu(false)}>About Us</Link></li>
            <li><Link to="/contact-us" onClick={() => setMobileMenu(false)}>Contact Us</Link></li>
          </ul>

          <div className="navbar-btn">
            <Link to="https://flyabasinexpress.com/" target="_blank" rel="noopener noreferrer">
              <button>B2B Login</button>
            </Link>
            <Link to="https://flyabasinexpress.com/agent-registration" target="_blank" rel="noopener noreferrer">
              <button>Register</button>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
